module.exports = __webpack_public_path__ + "static/media/cloudy.88d14389.png";